import React from "react";
import {connect} from 'react-redux';
import { Worker, Viewer } from "@react-pdf-viewer/core";
import { toolbarPlugin } from "@react-pdf-viewer/toolbar";
import { IconButton } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/toolbar/lib/styles/index.css";
import './pdf.css';

// Custom rendering function for the PDF pages
const renderPage = ({watermark,companyName,...props}) => (
  <>
    {props.canvasLayer.children}

    {/* Custom Watermark */}
    <div
      style={{
        alignItems: "center",
        display: "flex",
        height: "100%",
        justifyContent: "center",
        left: 0,
        position: "absolute",
        top: 0,
        width: "100%",
        pointerEvents: "none", // Prevent interaction with the watermark
      }}
    >
      <div
        style={{
          color: "rgba(0, 0, 0, 0.2)",
          fontSize: `${3 * props.scale}rem`,
          fontWeight: "bold",
          textTransform: "uppercase",
          transform: "rotate(-45deg)",
          userSelect: "none",
          display:'flex',
          flexDirection:'column',
          justifyContent:'center',
          alignItems:'center',
          fontFamily: "'Cairo', sans-serif"
        }}
      >
        <span>{companyName}</span>
        <span>{watermark}</span>
      </div>
    </div>

    {/* Disable text selection */}
    {props.annotationLayer.children}
    <div style={{ userSelect: "none" }}>{props.textLayer.children}</div>
  </>
);


const PDFViewer = (props) => {
    const {file, user, company, closeDialog,pdfFileUpdation, contentId, contentLogs } = props;
    const userName = `${user?.firstName || ''} ${user?.lastName || ''}`;
    const companyName = company?.name || '';
    // Toolbar plugin to remove the download and print buttons
    const toolbarPluginInstance = toolbarPlugin();
    const { renderDefaultToolbar, Toolbar } = toolbarPluginInstance;
    const { currentPage=1 } = contentLogs?.length && contentId ? contentLogs.filter(v=> v.contentId === contentId)?.[0] || {} : {};


  const transform = (slot) => {
    return {
      ...slot,
      // These slots will be empty
      Download: () => <></>,
      DownloadMenuItem: () => <></>,
      Print: () => <></>,
      PrintMenuItem: () => <></>,
      Open: () => <></>,
      OpenMenuItem: () => <></>,
      ShowProperties: () => <></>,
      ShowPropertiesMenuItem: () => <></>,
      SwitchTheme: () => <></>,
      SwitchThemeMenuItem: () => <></>,
      SwitchSelectionMode: () => <></>,
      SwitchSelectionModeMenuItem: () => <></>
    };
  };

    const pageOnChange = e => {
        const currentPage = e.currentPage + 1;
        const totalPages = e?.doc?._pdfInfo?.numPages;
        const downloaded = currentPage === totalPages || null;
        const completed = currentPage === totalPages || null;
        pdfFileUpdation(contentId,{currentPage:currentPage,downloaded, completed})
    };

  return (
    (<Worker
      workerUrl={`https://unpkg.com/pdfjs-dist@3.4.120/build/pdf.worker.min.js`}
    >
      <div style={{ height:'100%', position: "relative" }}>
        <div 
            style={{
                display: 'flex', alignItems: 'center', backgroundColor: '#3D5AF1', 
                boxShadow: '0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12)'
            }}
        >
            <Toolbar>{renderDefaultToolbar(transform)}</Toolbar>
            <IconButton
              onClick={closeDialog}
              style={{ marginLeft: 'auto',color:'#fff' }}
              size="large">
                <CloseIcon />
            </IconButton>
        </div>

        {/* PDF Viewer with custom renderPage function */}
        <Viewer
            fileUrl={file}
            initialPage={currentPage-1}
            onPageChange={pageOnChange}
            renderPage={props=> renderPage({watermark:userName,companyName,...props})}
            plugins={[toolbarPluginInstance]}
        />
      </div>
    </Worker>)
  );
};

const mapStateToProps = state => {
    return {
        user: state.user,
        company:state.company,
        company_id: state.company_id,
        singleSession: state.singleSession,
    }
}

export default connect(mapStateToProps,null)(PDFViewer);